export async function initAlert() {
    const initFunction = () => {
        const cookieBannerIsOpen = document.documentElement.classList.contains('show--settings');

        if (cookieBannerIsOpen) {
            document.querySelector('#s-all-bn')?.addEventListener('click', () => {
                initFunction();
            });

            return;
        }

        const TTL = 1000 * 60 * 60 * 24 * 30; // 30 days

        // Clean up expired localStorage items
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (!key?.startsWith('wp_alert')) continue;

            const value = localStorage.getItem(key);
            if (!value) continue;

            try {
                const [, created] = value.split(':');
                if (Date.now() - Number(created) > TTL) {
                    localStorage.removeItem(key);
                }
            } catch {
                localStorage.removeItem(key);
            }
        }

        const target = document.querySelector('#wp_alert');
        if (!target) return;

        if (!(target instanceof HTMLDialogElement)) {
            throw new Error('Target is not a dialog');
        }

        const { openInitially, uid, timestamp } = target.dataset;
        if (!timestamp) throw new Error('Timestamp is empty');
        if (!uid) throw new Error('UID is empty');

        const storageKey = `wp_alert:${uid}`;

        if (openInitially === '1') {
            const stored = localStorage.getItem(storageKey);

            if (!stored) {
                // If there is no stored value, show the modal
                target.showModal();
            } else {
                try {
                    // If there is a stored value, check if it is the same as the current timestamp
                    const [storedTimestamp] = stored.split(':');
                    if (storedTimestamp !== timestamp) {
                        target.showModal();
                    }
                } catch {
                    // If there is an error, remove the stored value and show the modal
                    localStorage.removeItem(storageKey);
                    target.showModal();
                }
            }
        }

        target.querySelector('.btn-alert-dismiss')?.addEventListener('click', () => {
            // Store the current timestamp and the current timestamp in milliseconds
            localStorage.setItem(storageKey, `${timestamp}:${Date.now()}`);
        });
    }

    setTimeout(() => { initFunction(); }, 100);
}